import _ from "lodash";
import Auth from "../Authentication/Auth";

const requireRolesHook = {
  criteria: {
    to: state => state.requiredRoles
  },
  callback: async transition => {
    const { requiredRoles } = transition.to();
    const userRoles = Auth.getUserRoles();

    if (!_.isEmpty(requiredRoles) && !_.some(userRoles, role => _.includes(requiredRoles, role))) {
      transition.router.stateService.go("403");
      return false;
    }

    return true;
  }
};

export default requireRolesHook;



// WEBPACK FOOTER //
// ./src/helpers/Authorization/requireRolesHook.js